if ( process.env.NODE_ENV !== 'production' ) {
    console.warn( 'ENABLE Hot module replacement' );
    try {
        module.hot.accept();
        if ( module.hot ) {
            require( 'preact/debug' );
        }
    }
    catch ( err ) {
        console.log( err );
    }
}
